import { render, staticRenderFns } from "./CreateMatchTutorial.vue?vue&type=template&id=78f5c6a0&scoped=true&"
import script from "./CreateMatchTutorial.vue?vue&type=script&lang=js&"
export * from "./CreateMatchTutorial.vue?vue&type=script&lang=js&"
import style0 from "./CreateMatchTutorial.vue?vue&type=style&index=0&id=78f5c6a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f5c6a0",
  null
  
)

export default component.exports